// base
import React from 'react';

// style
import { StyledTextButton } from './style';

// libraries
import { type ButtonProps } from '@mui/material';

type ButtonVariant = NonNullable<ButtonProps['variant']>;

export interface TextButtonProps extends Omit<ButtonProps, 'variant'> {
  label: string;
  variant?: ButtonVariant;
}

export const TextButton: React.FC<TextButtonProps> = ({
  variant = 'contained',
  children,
  label,
  ...props
}) => {
  return (
    <StyledTextButton disableRipple variant={variant} {...props}>
      {label}
      {children}
    </StyledTextButton>
  );
};
